import { css } from '@emotion/react';

import { theme } from 'global';

export const description = css`
  margin: 32px 0;
  max-width: ${theme.maxTextWidth};
`;
